import { noop } from 'lodash';

type Fn = () => void;

function addClickInterceptor(callback: Fn): Fn {
    let logo: Element | null = null;

    logo = document.querySelector('[data-betting-click-interceptor]');

    /* old classes to ensure compatibility. remove this after CMS changes */
    if (!logo) {
        // desktop classes
        logo = document.querySelector('.header-row .logo');
    }

    if (!logo) {
        // mobile classes
        logo =
            document.querySelectorAll('.wrapper .header__menu-logo')[1] ?? null;
    }
    /* end */

    if (!logo) {
        return noop;
    }

    const listener = (event: Event) => {
        event.preventDefault();

        callback();
    };

    const element: Element = logo;

    element.addEventListener('click', listener);

    return () => {
        element.removeEventListener('click', listener);
    };
}

export default addClickInterceptor;
